"use client";

import { Atom, Beaker, Box, Cpu, Droplet, Flame, Layers, Shield } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function InformationsPratiques() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: gridRef,
    isVisible: gridVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const materials = [{
    name: "Consultations",
    description: "Un espace d'écoute bienveillant pour aborder votre post-partum avec sérénité et confiance.",
    tensile: "Genève",
    temp: "Nyon",
    Icon: Layers
  }, {
    name: "Batch Cooking",
    description: "Préparation de repas nutritifs et réconfortants pour vous permettre de vous reposer pleinement.",
    tensile: "Sain",
    temp: "Local",
    Icon: Droplet
  }, {
    name: "Le Cercle",
    description: "Rencontres entre mamans pour partager vos expériences dans un cadre intime et sécurisant.",
    tensile: "Échange",
    temp: "Soutien",
    Icon: Beaker
  }, {
    name: "Le Village",
    description: "Un réseau de professionnels de confiance pour vous entourer durant cette période de transition.",
    tensile: "Expertise",
    temp: "Proximité",
    Icon: Box
  }, {
    name: "Soins Maman",
    description: "Des rituels de soin doux pour honorer votre corps et favoriser votre récupération physique.",
    tensile: "Détente",
    temp: "Douceur",
    Icon: Atom
  }, {
    name: "Accompagnement",
    description: "Un suivi personnalisé à domicile pour répondre à vos besoins spécifiques et ceux de votre bébé.",
    tensile: "Sur-mesure",
    temp: "Bien-être",
    Icon: Shield
  }, {
    name: "Ateliers",
    description: "Des moments d'apprentissage autour du portage, du sommeil ou de l'éveil de votre enfant.",
    tensile: "Pratique",
    temp: "Partage",
    Icon: Cpu
  }, {
    name: "Ressources",
    description: "Une sélection de conseils et d'outils pour vous accompagner au quotidien avec sérénité.",
    tensile: "Conseils",
    temp: "Clarté",
    Icon: Flame
  }];
  return;
}